// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/profiletype/v1/profiletype.proto" (package "c1.api.profiletype.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ProfileTypeUserAttributeMappingBindingService } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceUpdateResponse } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceUpdateRequest } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceListResponse } from "./profiletype";
import type { ProfileTypeUserAttributeMappingBindingServiceListRequest } from "./profiletype";
import { ProfileTypeSearchService } from "./profiletype";
import type { ProfileTypeSearchByAttributeMappingIdResponse } from "./profiletype";
import type { ProfileTypeSearchByAttributeMappingIdRequest } from "./profiletype";
import type { ProfileTypeSearchResponse } from "./profiletype";
import type { ProfileTypeSearchRequest } from "./profiletype";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ProfileTypeService } from "./profiletype";
import type { SetProfileTypeIconResponse } from "./profiletype";
import type { SetProfileTypeIconRequest } from "./profiletype";
import type { ProfileTypeServiceDeleteResponse } from "./profiletype";
import type { ProfileTypeServiceDeleteRequest } from "./profiletype";
import type { ProfileTypeServiceUpdateResponse } from "./profiletype";
import type { ProfileTypeServiceUpdateRequest } from "./profiletype";
import type { ProfileTypeServiceCreateResponse } from "./profiletype";
import type { ProfileTypeServiceCreateRequest } from "./profiletype";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ProfileTypeServiceGetResponse } from "./profiletype";
import type { ProfileTypeServiceGetRequest } from "./profiletype";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeService
 */
export interface IProfileTypeServiceClient {
    /**
     * Get a profile type by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ProfileTypeServiceGetRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceGetRequest, ProfileTypeServiceGetResponse>;
    /**
     * Create a profile type
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ProfileTypeServiceCreateRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceCreateRequest, ProfileTypeServiceCreateResponse>;
    /**
     * Update a profile type
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ProfileTypeServiceUpdateRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceUpdateRequest, ProfileTypeServiceUpdateResponse>;
    /**
     * Delete a profile type by ID
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ProfileTypeServiceDeleteRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceDeleteRequest, ProfileTypeServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: SetProfileTypeIcon
     */
    setProfileTypeIcon(input: SetProfileTypeIconRequest, options?: RpcOptions): UnaryCall<SetProfileTypeIconRequest, SetProfileTypeIconResponse>;
}
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeService
 */
export class ProfileTypeServiceClient implements IProfileTypeServiceClient, ServiceInfo {
    typeName = ProfileTypeService.typeName;
    methods = ProfileTypeService.methods;
    options = ProfileTypeService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get a profile type by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ProfileTypeServiceGetRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceGetRequest, ProfileTypeServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeServiceGetRequest, ProfileTypeServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a profile type
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ProfileTypeServiceCreateRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceCreateRequest, ProfileTypeServiceCreateResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeServiceCreateRequest, ProfileTypeServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a profile type
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ProfileTypeServiceUpdateRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceUpdateRequest, ProfileTypeServiceUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeServiceUpdateRequest, ProfileTypeServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a profile type by ID
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ProfileTypeServiceDeleteRequest, options?: RpcOptions): UnaryCall<ProfileTypeServiceDeleteRequest, ProfileTypeServiceDeleteResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeServiceDeleteRequest, ProfileTypeServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetProfileTypeIcon
     */
    setProfileTypeIcon(input: SetProfileTypeIconRequest, options?: RpcOptions): UnaryCall<SetProfileTypeIconRequest, SetProfileTypeIconResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetProfileTypeIconRequest, SetProfileTypeIconResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeSearchService
 */
export interface IProfileTypeSearchServiceClient {
    /**
     * Search profile types
     *
     * @generated from protobuf rpc: Search
     */
    search(input: ProfileTypeSearchRequest, options?: RpcOptions): UnaryCall<ProfileTypeSearchRequest, ProfileTypeSearchResponse>;
    /**
     * Search profile types by attribute mapping IDs
     *
     * @generated from protobuf rpc: SearchByAttributeMappingId
     */
    searchByAttributeMappingId(input: ProfileTypeSearchByAttributeMappingIdRequest, options?: RpcOptions): UnaryCall<ProfileTypeSearchByAttributeMappingIdRequest, ProfileTypeSearchByAttributeMappingIdResponse>;
}
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeSearchService
 */
export class ProfileTypeSearchServiceClient implements IProfileTypeSearchServiceClient, ServiceInfo {
    typeName = ProfileTypeSearchService.typeName;
    methods = ProfileTypeSearchService.methods;
    options = ProfileTypeSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search profile types
     *
     * @generated from protobuf rpc: Search
     */
    search(input: ProfileTypeSearchRequest, options?: RpcOptions): UnaryCall<ProfileTypeSearchRequest, ProfileTypeSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeSearchRequest, ProfileTypeSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search profile types by attribute mapping IDs
     *
     * @generated from protobuf rpc: SearchByAttributeMappingId
     */
    searchByAttributeMappingId(input: ProfileTypeSearchByAttributeMappingIdRequest, options?: RpcOptions): UnaryCall<ProfileTypeSearchByAttributeMappingIdRequest, ProfileTypeSearchByAttributeMappingIdResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeSearchByAttributeMappingIdRequest, ProfileTypeSearchByAttributeMappingIdResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService
 */
export interface IProfileTypeUserAttributeMappingBindingServiceClient {
    /**
     * List profile type user attribute mapping bindings
     *
     * @generated from protobuf rpc: List
     */
    list(input: ProfileTypeUserAttributeMappingBindingServiceListRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceListRequest, ProfileTypeUserAttributeMappingBindingServiceListResponse>;
    /**
     * Update a profile type user attribute mapping binding
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, ProfileTypeUserAttributeMappingBindingServiceUpdateResponse>;
    /**
     * Count profile type user attribute mapping bindings by user attribute mapping ID
     *
     * @generated from protobuf rpc: CountByUserAttributeMappingId
     */
    countByUserAttributeMappingId(input: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse>;
}
/**
 * @generated from protobuf service c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService
 */
export class ProfileTypeUserAttributeMappingBindingServiceClient implements IProfileTypeUserAttributeMappingBindingServiceClient, ServiceInfo {
    typeName = ProfileTypeUserAttributeMappingBindingService.typeName;
    methods = ProfileTypeUserAttributeMappingBindingService.methods;
    options = ProfileTypeUserAttributeMappingBindingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * List profile type user attribute mapping bindings
     *
     * @generated from protobuf rpc: List
     */
    list(input: ProfileTypeUserAttributeMappingBindingServiceListRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceListRequest, ProfileTypeUserAttributeMappingBindingServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeUserAttributeMappingBindingServiceListRequest, ProfileTypeUserAttributeMappingBindingServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a profile type user attribute mapping binding
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, ProfileTypeUserAttributeMappingBindingServiceUpdateResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, ProfileTypeUserAttributeMappingBindingServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Count profile type user attribute mapping bindings by user attribute mapping ID
     *
     * @generated from protobuf rpc: CountByUserAttributeMappingId
     */
    countByUserAttributeMappingId(input: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, options?: RpcOptions): UnaryCall<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse>("unary", this._transport, method, opt, input);
    }
}
